import RESPONSES_LIST from './data/RESPONSES_LIST.json';

export function apiBackOfficeGetAllResponses() {
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve(RESPONSES_LIST);
        }, 1000);
    });
}
